import { Environment } from './types';

export const environment: Environment = {
    production: false,
    environment: 'develop',
    availableLanguages: ['en', 'es', 'sv'],
    availableCountries: ['USA', 'CAN', 'AUS', 'NZL'],
    doc360APIKey: 'g9S9cSkgviRFPxzNbQS92G7ZPLmHJrqE86V43oMqNhgkDzXhVDJy4GzjFcJa7e9rau5phkEC45Y5yo5Sr9lvo3eiPifm5B8PMqnTgP6uSACa4y0By1LwWFvUI9OedpCR3KMwblkBuq7e4W/SNYge5w==',
    mapboxGlAccessToken: 'pk.eyJ1IjoiZ2pzbWl0aDY2IiwiYSI6ImNrNzNwNTExazAxYXozZXBkYTNweGxiMnEifQ.3YVX6rt_9kPwWfH-aX3HUg',
    posthogApiKey: '',
    posthogApiHost: '',
    enablePosthog: false
};
